import { render, staticRenderFns } from "./vis-page-error.vue?vue&type=template&id=b914127e"
import script from "./vis-page-error.vue?vue&type=script&lang=js"
export * from "./vis-page-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports